// ----------------------------------------------------------------------

function path(root, sublink) {
    return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
    root: ROOTS_AUTH,
    login: path(ROOTS_AUTH, '/login'),
    operatorLogin: path(ROOTS_AUTH, '/operator-login'),
    register: path(ROOTS_AUTH, '/register'),
    loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
    registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
    verify: path(ROOTS_AUTH, '/verify'),
    resetPassword: path(ROOTS_AUTH, '/reset-password'),
    newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
    comingSoon: '/coming-soon',
    maintenance: '/maintenance',
};

export const PATH_DASHBOARD = {
    root: ROOTS_DASHBOARD,
    general: {
        app: path(ROOTS_DASHBOARD, '/home'),
        stationServices: path(ROOTS_DASHBOARD, '/stationServices'),
        new_invoice: path(ROOTS_DASHBOARD, '/home/newInvoice'),
        invoices: path(ROOTS_DASHBOARD, '/invoices'),
        busTickets: path(ROOTS_DASHBOARD, '/busTickets'),
        soldServices: path(ROOTS_DASHBOARD, '/reports/soldServices'),
        settings: path(ROOTS_DASHBOARD, '/settings'),
        notifications: path(ROOTS_DASHBOARD, '/notifications'),
    },
    reports: {
        root: path(ROOTS_DASHBOARD, '/reports'),
        overviewTicketAndOther: path(ROOTS_DASHBOARD, '/reports/overviewTicketAndOther'),
        overview: path(ROOTS_DASHBOARD, '/reports/overview'),
        validatedTicketReport: path(ROOTS_DASHBOARD, '/reports/validatedTicketReport'),
        actionsReport: path(ROOTS_DASHBOARD, '/reports/actionsReport'),
        liquidation: path(ROOTS_DASHBOARD, '/reports/liquidation'),
        multiPassValidations: path(ROOTS_DASHBOARD, '/reports/multiPassValidations'),
        multiPassesByClient: path(ROOTS_DASHBOARD, '/reports/multiPassesByClient'),
        internationalReport: path(ROOTS_DASHBOARD, '/reports/internationalReport'),
    },
    servicesReport: {
        root: path(ROOTS_DASHBOARD, '/services-report'),
        list: path(ROOTS_DASHBOARD, '/services-report/list'),
    },
    preview: {
        priceList: path(ROOTS_DASHBOARD, '/preview/priceList'),
        linesList: path(ROOTS_DASHBOARD, '/preview/linesList'),
        departuresList: path(ROOTS_DASHBOARD, '/preview/departuresList'),
        departuresLinkedList: path(ROOTS_DASHBOARD, '/preview/departuresLinkedList'),
        timesList: path(ROOTS_DASHBOARD, '/preview/timesList'),
        discountsList: path(ROOTS_DASHBOARD, '/preview/discountsList'),
        driveParkList: path(ROOTS_DASHBOARD, '/preview/driveParkList'),
        commentsList: path(ROOTS_DASHBOARD, '/preview/commentsList'),
        allotments: path(ROOTS_DASHBOARD, '/preview/allotmentList'),
        currentAllotments: path(ROOTS_DASHBOARD, '/preview/current-allotments'),
        cancelledTripsHistory: path(ROOTS_DASHBOARD, '/preview/cancelled-trips-history'),
        ratesHistory: path(ROOTS_DASHBOARD, '/preview/rates-history'),
        tripExceptionHistory: path(ROOTS_DASHBOARD, '/preview/trip-exception-history'),
        peronizationStatus: path(ROOTS_DASHBOARD, '/preview/peronization-status')
    },
    discounts: {
        root: path(ROOTS_DASHBOARD, '/discounts'),
        list: path(ROOTS_DASHBOARD, '/discounts/list'),
        new: path(ROOTS_DASHBOARD, '/discounts/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/discounts/${id}/edit`),
    },
    privileges: {
        root: path(ROOTS_DASHBOARD, '/privileges'),
        list: path(ROOTS_DASHBOARD, '/privileges/list'),
        new: path(ROOTS_DASHBOARD, '/privileges/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/privileges/${id}/edit`),
        listDisabilities: path(ROOTS_DASHBOARD, '/privileges/disability'),
        newDisability: path(ROOTS_DASHBOARD, '/privileges/disability-new'),
        editDisability: (id) => path(ROOTS_DASHBOARD, `/privileges/${id}/editDisability`),
    },
    dispatchCenter: {
        root: path(ROOTS_DASHBOARD, '/dispatch'),
        depots: path(ROOTS_DASHBOARD, '/dispatch/depots'),
        drivers: path(ROOTS_DASHBOARD, '/dispatch/drivers'),
        driverNew: path(ROOTS_DASHBOARD, '/dispatch/drivers/new'),
        driverEdit: (id) => path(ROOTS_DASHBOARD, `/dispatch/drivers/${id}/edit`),
        scheduleWeek: path(ROOTS_DASHBOARD, '/dispatch/schedule-week'),
        unassigned: path(ROOTS_DASHBOARD, '/dispatch/unassigned'),
        turnus: path(ROOTS_DASHBOARD, '/dispatch/turnus'),
        turnusNew: path(ROOTS_DASHBOARD, '/dispatch/turnus/new'),
        turnusEdit: (id) => path(ROOTS_DASHBOARD, `/dispatch/turnus/${id}/edit`),
        scheduleDay: path(ROOTS_DASHBOARD, '/dispatch/schedule-day'),
        turnusSchedule: path(ROOTS_DASHBOARD, '/dispatch/turnus-schedule'),
        driverReport: path(ROOTS_DASHBOARD, '/dispatch/driver-report'),
        travelOrders: path(ROOTS_DASHBOARD, '/dispatch/travel-orders'),
        fleet: path(ROOTS_DASHBOARD, '/dispatch/fleet'),
        fleetHistory: (vehicleId) => path(ROOTS_DASHBOARD, `/dispatch/fleet/${vehicleId}/history`),
    },
    cityTransport: {
        root: path(ROOTS_DASHBOARD, '/city'),
        lines: path(ROOTS_DASHBOARD, '/city/lines'),
        lineNew: path(ROOTS_DASHBOARD, '/city/lines/new'),
        lineEdit: (id) => path(ROOTS_DASHBOARD, `/city/lines/${id}/edit`),
        lineDepartures: (id) => path(ROOTS_DASHBOARD, `/city/lines/${id}/departures`),
        lineTimetable: (id) => path(ROOTS_DASHBOARD, `/city/lines/${id}/timetable`),
        exceptions: path(ROOTS_DASHBOARD, '/city/exceptions'),
        routes: path(ROOTS_DASHBOARD, '/city/routes'),
        routePlan: (lineId) => path(ROOTS_DASHBOARD, `/city/routes/${lineId}/plan`),
        zones: path(ROOTS_DASHBOARD, '/city/zones'),
        fares: path(ROOTS_DASHBOARD, '/city/fares'),
        passes: path(ROOTS_DASHBOARD, '/city/passes'),
        sale: path(ROOTS_DASHBOARD, '/city/sale'),
        cards: path(ROOTS_DASHBOARD, '/city/cards'),
        tickets: path(ROOTS_DASHBOARD, '/city/tickets'),
        invoices: path(ROOTS_DASHBOARD, '/city/invoices'),
        accountPasses: path(ROOTS_DASHBOARD, '/city/account-passes'),
        driverSettlement: path(ROOTS_DASHBOARD, '/city/driver-settlement'),
        employeeSettlement: path(ROOTS_DASHBOARD, '/city/employee-settlement'),
        reports: path(ROOTS_DASHBOARD, '/city/reports'),
        kilometers: path(ROOTS_DASHBOARD, '/city/kilometers'),
        vehicleReport: path(ROOTS_DASHBOARD, '/city/vehicle-report'),
        deviceReport: path(ROOTS_DASHBOARD, '/city/device-report'),
        financeReport: path(ROOTS_DASHBOARD, '/city/finance-report'),
        inspectorReport: path(ROOTS_DASHBOARD, '/city/inspector-report'),
        validations: path(ROOTS_DASHBOARD, '/city/validations'),
    },
    bus: {
        root: path(ROOTS_DASHBOARD, '/bus'),
        list: path(ROOTS_DASHBOARD, '/bus/list'),
        new: path(ROOTS_DASHBOARD, '/bus/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/bus/${id}/edit`),
    },
    priceList: {
        root: path(ROOTS_DASHBOARD, '/priceList'),
        list: path(ROOTS_DASHBOARD, '/priceList/list'),
        linkPriceTrip: path(ROOTS_DASHBOARD, '/priceList/linkPriceTrip'),
        stationsList: path(ROOTS_DASHBOARD, '/priceList/stationsList'),
        new: path(ROOTS_DASHBOARD, '/priceList/new'),
        newStation: path(ROOTS_DASHBOARD, '/priceList/newStation'),
        edit: (id) => path(ROOTS_DASHBOARD, `/priceList/${id}/edit`),
        instantEdit: path(ROOTS_DASHBOARD, `/priceList/instantEdit`),
        editStation: (id) => path(ROOTS_DASHBOARD, `/priceList/${id}/edit-station`),
        editStationService: (id) => path(ROOTS_DASHBOARD, `/priceList/${id}/instantEdit`),
    },
    items: {
        root: path(ROOTS_DASHBOARD, '/items'),
        list: path(ROOTS_DASHBOARD, '/items/list'),
        new: path(ROOTS_DASHBOARD, '/items/add'),
        editItems: (id) => path(ROOTS_DASHBOARD, `/items/${id}/edit`),
        rateCardItems: path(ROOTS_DASHBOARD, '/items/rate-card-items'),
    },
    holidays: {
        root: path(ROOTS_DASHBOARD, '/holidays'),
        list: path(ROOTS_DASHBOARD, '/holidays/list'),
        new: path(ROOTS_DASHBOARD, '/holidays/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/holidays/${id}/edit`),
    },
    stationList: {
        root: path(ROOTS_DASHBOARD, '/stationList'),
        list: path(ROOTS_DASHBOARD, '/stationList/list'),
        new: path(ROOTS_DASHBOARD, '/stationList/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/stationList/${id}/edit`),
    },
    departuresStatusList: {
        root: path(ROOTS_DASHBOARD, '/departuresStatus'),
        list: path(ROOTS_DASHBOARD, '/departuresStatus/list')
    },
    locationList: {
        root: path(ROOTS_DASHBOARD, '/locationList'),
        list: path(ROOTS_DASHBOARD, '/locationList/list'),
        new: path(ROOTS_DASHBOARD, '/locationList/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/locationList/${id}/edit`),
    },
    linesList: {
        root: path(ROOTS_DASHBOARD, '/linesList'),
        list: path(ROOTS_DASHBOARD, '/linesList/list'),
        new: path(ROOTS_DASHBOARD, '/linesList/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/linesList/${id.id}/edit`),
    },
    disabledLineStations: {
        root: path(ROOTS_DASHBOARD, '/disabledLineStations'),
        list: path(ROOTS_DASHBOARD, '/disabledLineStations/list'),
        new: path(ROOTS_DASHBOARD, '/disabledLineStations/new'),
    },
    departuresList: {
        root: path(ROOTS_DASHBOARD, '/departuresList'),
        list: path(ROOTS_DASHBOARD, '/departuresList/list'),
        new: path(ROOTS_DASHBOARD, '/departuresList/new'),
        bulkOperationalInterval: path(ROOTS_DASHBOARD, '/departuresList/bulkOperationalInterval'),
        linked: path(ROOTS_DASHBOARD, '/departuresList/linked'),
        departuresLinkedList: path(ROOTS_DASHBOARD, '/departuresList/departuresLinkedList'),
        departuresLinkedAttachRateCard: path(ROOTS_DASHBOARD, '/departuresList/departuresLinkedAttachRateCard'),
        departuresExceptions: path(ROOTS_DASHBOARD, '/departuresList/departuresExceptions'),
        edit: (id) => path(ROOTS_DASHBOARD, `/departuresList/${id}/edit`),
        editLinked: (id) => path(ROOTS_DASHBOARD, `/departuresList/${id}/editLinked`),
    },
    allotment: {
        root: path(ROOTS_DASHBOARD, '/allotment'),
        list: path(ROOTS_DASHBOARD, '/allotment/list'),
        new: path(ROOTS_DASHBOARD, '/allotment/new'),
        assigned: path(ROOTS_DASHBOARD, '/allotment/assigned'),
        assign: path(ROOTS_DASHBOARD, '/allotment/assign'),
        edit: (id) => path(ROOTS_DASHBOARD, `/allotment/${id}/edit`),
        //board: (thvId) => path(ROOTS_DASHBOARD, `/allotment/board/${thvId}`),
    },
    tripSeatStatus: {
        root: path(ROOTS_DASHBOARD, '/tripSeatStatus'),
        list: path(ROOTS_DASHBOARD, '/tripSeatStatus/list'),
        edit: (id) => path(ROOTS_DASHBOARD, `/tripSeatStatus/${id}/edit`),
    },
    timesList: {
        root: path(ROOTS_DASHBOARD, '/timesList'),
        list: path(ROOTS_DASHBOARD, '/timesList/list'),
        new: path(ROOTS_DASHBOARD, '/timesList/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/timesList/${id}/edit`),
    },
    promoNotifications: {
        root: path(ROOTS_DASHBOARD, '/promoNotifications'),
        list: path(ROOTS_DASHBOARD, '/promoNotifications/list'),
    },
    actions: {
        root: path(ROOTS_DASHBOARD, '/actionsList'),
        list: path(ROOTS_DASHBOARD, '/actionsList/list'),
        new: path(ROOTS_DASHBOARD, '/actionsList/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/actionsList/${id}/edit`),
        actionValueList: path(ROOTS_DASHBOARD, '/actionsList/actionValueList'),
        actionValueNew: path(ROOTS_DASHBOARD, '/actionsList/actionValueNew'),
        actionValueListEdit: (id) => path(ROOTS_DASHBOARD, `/actionsList/${id}/actionValueListEdit`),
    },
    monthlyTicketsList: {
        root: path(ROOTS_DASHBOARD, '/monthlyTicketsList'),
        list: path(ROOTS_DASHBOARD, '/monthlyTicketsList/list'),
        new: path(ROOTS_DASHBOARD, '/monthlyTicketsList/new'),
        extend: path(ROOTS_DASHBOARD, '/monthlyTicketsList/extend'),
        edit: (id) => path(ROOTS_DASHBOARD, `/monthlyTicketsList/${id}/edit`),
    },
    customers: {
        root: path(ROOTS_DASHBOARD, '/customers'),
        list: path(ROOTS_DASHBOARD, '/customers/list'),
        new: path(ROOTS_DASHBOARD, '/customers/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/customers/${id.uid}/edit`),
    },
    carriers: {
        root: path(ROOTS_DASHBOARD, '/carriers'),
        list: path(ROOTS_DASHBOARD, '/carriers/list'),
        new: path(ROOTS_DASHBOARD, '/carriers/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/carriers/${id}/edit`),
    },
    otpravnik: {
        root: path(ROOTS_DASHBOARD, '/otpravnik'),
        publisher: path(ROOTS_DASHBOARD, '/otpravnik/publisher'),
        other: path(ROOTS_DASHBOARD, '/otpravnik/other'),
        list: path(ROOTS_DASHBOARD, '/otpravnik/list'),
        new: path(ROOTS_DASHBOARD, '/otpravnik/new'),
        trafficLogs: path(ROOTS_DASHBOARD, '/otpravnik/all-logs'),
        actionLog: path(ROOTS_DASHBOARD, '/otpravnik/action-log'),
        unusedCameraEvents: path(ROOTS_DASHBOARD, '/otpravnik/unused'),
        newBIS: path(ROOTS_DASHBOARD, '/otpravnik/new-bis'),
        edit: (id) => path(ROOTS_DASHBOARD, `/otpravnik/${id.uid}/edit`),
    },
    scheduledDepAndArr: {
        root: path(ROOTS_DASHBOARD, '/scheduledDepAndArr'),
        list: path(ROOTS_DASHBOARD, '/scheduledDepAndArr/list'),
    },
    peronization: {
        root: path(ROOTS_DASHBOARD, '/peronization'),
        list: path(ROOTS_DASHBOARD, '/peronization/list'),
        price: path(ROOTS_DASHBOARD, '/peronization/price'),
        new: path(ROOTS_DASHBOARD, '/peronization/new'),
    },
    parking: {
        root: path(ROOTS_DASHBOARD, '/parking'),
        list: path(ROOTS_DASHBOARD, '/parking/list'),
    },
    parkingServices: {
        root: path(ROOTS_DASHBOARD, '/parking-services'),
        list: path(ROOTS_DASHBOARD, '/parking-services/list'),
        new: path(ROOTS_DASHBOARD, '/parking-services/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/parking-services/${id}/edit`),
    },
    stationLineAssignment: {
        root: path(ROOTS_DASHBOARD, '/station-line-assignment'),
        list: path(ROOTS_DASHBOARD, '/station-line-assignment/list'),
    },
    receivingShipping: {
        root: path(ROOTS_DASHBOARD, '/receivingShipping'),
        list: path(ROOTS_DASHBOARD, '/receivingShipping/list'),
    },
    carrierReport: {
        root: path(ROOTS_DASHBOARD, '/carrierReport'),
        edit: path(ROOTS_DASHBOARD, '/carrierReport/edit'),
        sumarized: path(ROOTS_DASHBOARD, '/carrierReport/sumarized'),
        detailed: path(ROOTS_DASHBOARD, '/carrierReport/Detailed'),
        tickets: path(ROOTS_DASHBOARD, '/carrierReport/Tickets'),
        returnTickets: path(ROOTS_DASHBOARD, '/carrierReport/ReturnTickets'),
        validatedTickets: path(ROOTS_DASHBOARD, '/carrierReport/ValidatedTickets'),
        privilegesTickets: path(ROOTS_DASHBOARD, '/carrierReport/PrivilegesTickets'),
        discountedTickets: path(ROOTS_DASHBOARD, '/carrierReport/DiscountedTickets'),
        ticketOperatorStats: path(ROOTS_DASHBOARD, '/carrierReport/TicketOperatorStats'),
        ticketSalesFinancialReport: path(ROOTS_DASHBOARD, '/carrierReport/ticketSalesFinancialReport'),
        whiteList: path(ROOTS_DASHBOARD, '/carrierReport/whiteList'),
    },
    otherSalesChannels: {
        root: path(ROOTS_DASHBOARD, '/otherSalesChannels'),
        fidkp: path(ROOTS_DASHBOARD, '/otherSalesChannels/fidkp'),
    },
    commissionCalculation: {
        root: path(ROOTS_DASHBOARD, '/commissionCalculation'),
        list: path(ROOTS_DASHBOARD, '/commissionCalculation/list'),
        //allTickets: path(ROOTS_DASHBOARD, '/commissionCalculation/all-tickets'),
        incomeForStation: path(ROOTS_DASHBOARD, '/commissionCalculation/incomeForStation'),
        additionalIncomeBalance: path(ROOTS_DASHBOARD, '/commissionCalculation/additionalIncomeBalance'),
        additionalIncome: path(ROOTS_DASHBOARD, '/commissionCalculation/additionalIncome'),
        analyticsAndCommissions: path(ROOTS_DASHBOARD, '/commissionCalculation/analyticsAndCommissions'),
        additionalRevenueDetailedReport: path(ROOTS_DASHBOARD, '/commissionCalculation/additionalRevenueDetailedReport'),
    },
    insurance: {
        root: path(ROOTS_DASHBOARD, '/insurance'),
        list: path(ROOTS_DASHBOARD, '/insurance/list'),
        new: path(ROOTS_DASHBOARD, '/insurance/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/insurance/${id.uid}/edit`),
    },
    platforms: {
        root: path(ROOTS_DASHBOARD, '/platforms'),
        list: path(ROOTS_DASHBOARD, '/platforms/list'),
        new: path(ROOTS_DASHBOARD, '/platforms/new'),
        busyness: path(ROOTS_DASHBOARD, '/platforms/busyness'),
        busynessBuilder: (id) => path(ROOTS_DASHBOARD, `/platforms/busyness/${id}`),
        edit: (id) => path(ROOTS_DASHBOARD, `/platforms/${id}/edit`),
    },
    operators: {
        root: path(ROOTS_DASHBOARD, '/operators'),
        list: path(ROOTS_DASHBOARD, '/operators/list'),
        new: path(ROOTS_DASHBOARD, '/operators/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/operators/${id}/edit`),
    },
    comments: {
        root: path(ROOTS_DASHBOARD, '/comments'),
        list: path(ROOTS_DASHBOARD, '/comments/list'),
        new: path(ROOTS_DASHBOARD, '/comments/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/comments/${id.uid}/edit`),
    },
    admin: {
        root: path(ROOTS_DASHBOARD, '/admin'),
        routes: path(ROOTS_DASHBOARD, '/routes'),
        availabilityCheck: path(ROOTS_DASHBOARD, '/availability-check'),
        statistics: path(ROOTS_DASHBOARD, '/admin/statistics')
    },
    barriers: {
        root: path(ROOTS_DASHBOARD, '/barriers'),
        new: path(ROOTS_DASHBOARD, '/barriers/new'),
        list: path(ROOTS_DASHBOARD, '/barriers/list'),
        terminals: path(ROOTS_DASHBOARD, '/barriers/terminals'),
        partners: path(ROOTS_DASHBOARD, '/barriers/partners'),
        reports: path(ROOTS_DASHBOARD, '/barriers/reports'),
    },
    projectImprovements: {
        root: path(ROOTS_DASHBOARD, '/projectImprovements'),
        details: path(ROOTS_DASHBOARD, '/projectImprovements/details'),
        updates: path(ROOTS_DASHBOARD, '/projectImprovements/updates'),
        requests: path(ROOTS_DASHBOARD, '/projectImprovements/requests'),
        bugs: path(ROOTS_DASHBOARD, '/projectImprovements/bugs'),
        newBug: path(ROOTS_DASHBOARD, '/projectImprovements/bugs/new'),
    }
};

